import script from "./leave-type-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./leave-type-modal.vue?vue&type=script&setup=true&lang=js"

import "./leave-type-modal.vue?vue&type=style&index=0&id=d3818842&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3818842"]])

export default __exports__